// extracted by mini-css-extract-plugin
module.exports = {"section":"_3cMA9-","content":"_3qcgje"};